// Curated set of condition keys the onboarding survey is allowed to show,
// ported verbatim from Sparta (`sparta/src/user/constants/healthConditions.ts`)
// so onboarding matches the web flow. The `/api/v4/health_conditions/` catalog
// can return more keys than these (e.g. `overweight` / `obesity`); anything not
// listed here is filtered out — see `useHealthConditions`.
const HEALTH_CONDITIONS = {
  DEPRESSION: 'depression',
  PREDIABETES: 'prediabetes',
  DIABETES: 'diabetes',
  HIGH_BLOOD_PRESSURE: 'high-blood-pressure',
  HIGH_CHOLESTEROL: 'high-cholesterol',
  OTHER_MEDICAL: 'other-medical',
  ANXIETY: 'anxiety',
  ASTHMA: 'asthma',
  BACK_PAIN: 'back-pain',
  COPD: 'copd',
  SLEEP_APNEA: 'sleep-apnea',
  SLEEP_PROBLEMS: 'sleep-problems',
  SMOKING_OR_NICOTINE_USE: 'smoking/nicotine-use',
  PERIPHERAL_ARTERY_OR_VASCULAR_DISEASE: 'peripheral-artery/vascular-disease',
  CHF: 'chf',
  ARRHYTHMIA: 'arrhythmia',
} as const;

export const WHITELISTED_HEALTH_CONDITIONS: readonly string[] = Object.values(HEALTH_CONDITIONS);
